import { useMemo } from 'react';
import useTreeData from '../queries/useTreeData';

const usePreparedForTreeData = (
  selectedRooms,
  setSelectedRooms,
  debouncedSearch,
  isTenantExist
) => {
  const { data: treeData, isFetching } = useTreeData(
    debouncedSearch,
    isTenantExist
  );
  const preparedData = useMemo(() => {
    return treeData.map((facility) => ({
      ...facility,
      label: facility.name,
      canBeChecked: true,
      checked: !!facility.floors.every((floor) =>
        floor.offices?.every((office) =>
          selectedRooms.find((room) => office.id === room.id)
        )
      ),
      indeterminate: !!facility.floors.some((floor) =>
        floor.offices?.some((office) =>
          selectedRooms.find((room) => office.id === room.id)
        )
      ),
      onSelectChange: (object, checked) => {
        if (checked) {
          setSelectedRooms((selectedRooms) => [
            ...selectedRooms,
            ...object.floors?.reduce((acc, floor) => {
              return [...acc, ...floor.offices];
            }, []),
          ]);
        } else {
          setSelectedRooms((selectedRooms) => {
            const res = selectedRooms.filter(
              (room) =>
                !object.floors.find((floor) =>
                  floor.offices.find((office) => office.id === room.id)
                )
            );
            return res;
          });
        }
      },
      children: facility.floors?.map((floor) => ({
        ...floor,
        label: `${floor.floor} этаж`,
        canBeChecked: true,
        onSelectChange: (object, checked) => {
          if (checked) {
            setSelectedRooms((selectedRooms) => [
              ...selectedRooms,
              ...object.offices,
            ]);
          } else {
            setSelectedRooms((selectedRooms) =>
              selectedRooms.filter(
                (room) =>
                  !object.offices.find((office) => office.id === room.id)
              )
            );
          }
        },
        checked: !!floor.offices?.every((office) =>
          selectedRooms.find((room) => office.id === room.id)
        ),
        indeterminate: !!floor.offices.some((office) =>
          selectedRooms.find((room) => office.id === room.id)
        ),
        children: floor.offices?.map((room) => ({
          ...room,
          label: room.name,
          canBeChecked: true,
          onSelectChange: (object, checked) => {
            if (checked) {
              setSelectedRooms((selectedRooms) => [...selectedRooms, object]);
            } else {
              setSelectedRooms((selectedRooms) =>
                selectedRooms.filter((room) => room.id !== object.id)
              );
            }
          },
          checked: !!selectedRooms.find((office) => office.id === room.id),
          indeterminate: !!selectedRooms.find(
            (office) => office.id === room.id
          ),
        })),
      })),
    }));
  }, [treeData, selectedRooms, setSelectedRooms]);
  return [preparedData, isFetching];
};

export default usePreparedForTreeData;
